<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :data2="graph1.data2" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph2('company')">관련 부서</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph2('field')">사업장/시설물</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph2('detail')">상세항목</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card :title="graph3.title" :unit="graph3.unit" :begin-date="graph3.beginDate" :end-date="graph3.endDate" :list="graph3.list" @change="dateRangeChangeForGraph3">
          <template v-if="projectId" slot="tools" :set="(lv = getLevel)">
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph3('company')">관련 부서</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph3('field')">사업장/시설물</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph3('detail')">예산항목</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
import GraphUtil from "@/util/GraphUtil";
import MonthlyComparisonUtil from "@/util/MonthlyComparisonUtil";
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard.vue";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard.vue";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard.vue";
import DailyComparisonUtil from "@/util/DailyComparisonUtil";
import CircleGraphUtil from '@/util/CircleGraphUtil'
export default {
  name: "GraphDetail05",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
  },
  data() {
    return {
      boardIds: [311, 317, 337,],
      summaryKey: ["안전계획_종류", "count"],
      graph1: {
        title: "전체 시설물 안전계획 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 시설물 안전계획 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "분야명" }, { name: "예산" }, { name: "전월대비 증감" }],
        list: [],
        dataType: this.$route.params.proj_id ? "detail" : "project",
      },
      graph3: {
        title: "기간별 시설물 안전계획 현황",
        unit: "",
        beginDate: new Date().format("yyyy-MM-dd"),
        endDate: new Date().format("yyyy-MM-dd"),
        list: [],
        dataType: this.$route.params.proj_id ? "detail" : "project",
      },
    };
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
  },
  methods: {
    // 그래프 1
    async loadGraph1() {
      const summaryKey = this.summaryKey;
      const dataList = await this.loadGraph1Piece(this.boardIds, summaryKey);

      let graph = {
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
      if (dataList && dataList.length > 0) {
        for (const data of dataList) {
          graph = GraphUtil.combine월별총합막대그래프(graph, data);
        }
      }
      this.graph1.data1 = graph.data1;
      this.graph1.data2 = graph.data2;
    },
    async loadGraph1Piece(boardIds, summaryKey) {
      const value = await this.$store
        .dispatch("summary/FIRA_LOAD_SUMMARY", {
          boardIds,
          projectIds: this.projectId ? [this.projectId] : [],
          beginAt: `${this.graph1.year - 1}-01-01 00:00:00`,
          endAt: `${this.graph1.year}-12-31 23:59:59`,
        })
        .then((value) => {
          const boardIds = this.boardIds
          const dataList = []
          for (const boardId of boardIds) {
            dataList.push(GraphUtil.getData월별총합막대그래프(value[boardId], this.graph1.year, summaryKey))
          }
          return dataList;
        });
      return value;
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      let summaryKey = ["안전계획_종류", "count"];
      if (this.graph2.dataType === "field") {
        summaryKey = ["안전계획_사업장명", "count"];
      }
      const dataList = await this.loadGraph2Piece(this.boardIds, summaryKey);

      let graph = {}
      if (dataList && dataList.length > 0) {
        for (const data of dataList) {
          graph = MonthlyComparisonUtil.sumValueFromEachCompany(graph, data);
        }
      }

      this.graph2.list = MonthlyComparisonUtil.moduleWithData(graph);
    },
    async loadGraph2Piece(boardIds, summaryKey) {
      const value = await this.$store
        .dispatch("summary/FIRA_LOAD_SUMMARY", {
          boardIds,
          projectIds: this.projectId ? [this.projectId] : [],
          beginAt: `${this.graph2.year}-01-01 00:00:00`,
          endAt: `${this.graph2.year}-12-31 23:59:59`,
        })
        .then((value) => {
          const boardIds = this.boardIds
          const dataList = []
          for (const boardId of boardIds) {
            if (this.graph2.dataType === "project") {
              dataList.push(MonthlyComparisonUtil.getProjectFromEachProject(value[boardId], this.graph2.year, this.graph2.month, summaryKey));
            } else if (this.graph2.dataType === "company") {
              dataList.push(MonthlyComparisonUtil.getCompanyFromEachCompany(value[boardId], this.graph2.year, this.graph2.month, summaryKey));
            } else {
              dataList.push(MonthlyComparisonUtil.getColumnFromEachCompany(value[boardId], this.graph2.year, this.graph2.month, summaryKey));
            }

          }
          return dataList;
        });
      return value;
    },
    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.value;
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
      }
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType) {
      if (this.projectId) {
        this.graph2.dataType = dataType;
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      let summaryKey = ["안전계획_종류", "count"];
      if (this.graph3.dataType === "field") {
        summaryKey = ["안전계획_사업장명", "count"];
      }

      const dataList = await this.loadGraph3Piece(this.boardIds, summaryKey);

      let graph = {}
      if (dataList && dataList.length > 0) {
        for (const data of dataList) {
          graph = DailyComparisonUtil.sumValueFromEachCompany(graph, data);
        }
      }

      this.graph3.list = GraphUtil.moduleWithData(graph);
    },
    async loadGraph3Piece(boardIds, summaryKey) {
      const beginAt = new Date(this.graph3.beginDate).format("yyyy-MM-dd 00:00:00");
      const endAt = new Date(this.graph3.endDate).format("yyyy-MM-dd 23:59:59");

      const value = await this.$store
        .dispatch("summary/FIRA_LOAD_SUMMARY", {
          boardIds,
          projectIds: this.projectId ? [this.projectId] : [],
          beginAt,
          endAt,
        })
        .then((value) => {
          const boardIds = this.boardIds
          const dataList = []
          for (const boardId of boardIds) {
            if (this.graph3.dataType === "project") {
              dataList.push(DailyComparisonUtil.getProjectFromEachProject(value[boardId], summaryKey));
            } else if (this.graph3.dataType === "company") {
              dataList.push(DailyComparisonUtil.getCompanyFromEachCompany(value[boardId], summaryKey));
            } else {
              dataList.push(DailyComparisonUtil.getColumnFromEachCompany(value[boardId], summaryKey));
            }

          }
          return dataList;
        });

      return value;
    },
    dateRangeChangeForGraph3(beginDate, endDate) {
      this.graph3.beginDate = beginDate;
      this.graph3.endDate = endDate;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },
  },
};
</script>

<style scoped></style>
